interface IArrowIconProps {
	direction?: "top" | "bottom" | "left" | "right";
	color?: string;
	width?: string;
}

function ArrowIcon({ direction, width }: IArrowIconProps) {
	const directionMap = {
		top: "270deg",
		bottom: "90deg",
		left: "180deg",
		right: "0deg",
	};

	return (
		<svg
			width={width || "16"}
			viewBox="0 0 16 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={{ transform: `rotate(${directionMap[direction || "bottom"]})` }}
		>
			<path
				d="M15.3172 7.44229L9.69219 13.0673C9.57491 13.1846 9.41585 13.2504 9.25 13.2504C9.08415 13.2504 8.92509 13.1846 8.80781 13.0673C8.69054 12.95 8.62465 12.791 8.62465 12.6251C8.62465 12.4592 8.69054 12.3002 8.80781 12.1829L13.3664 7.6251H1.125C0.95924 7.6251 0.800269 7.55925 0.683058 7.44204C0.565848 7.32483 0.5 7.16586 0.5 7.0001C0.5 6.83434 0.565848 6.67537 0.683058 6.55816C0.800269 6.44095 0.95924 6.3751 1.125 6.3751H13.3664L8.80781 1.81729C8.69054 1.70002 8.62465 1.54096 8.62465 1.3751C8.62465 1.20925 8.69054 1.05019 8.80781 0.932916C8.92509 0.81564 9.08415 0.749756 9.25 0.749756C9.41585 0.749756 9.57491 0.81564 9.69219 0.932916L15.3172 6.55791C15.3753 6.61596 15.4214 6.68489 15.4529 6.76076C15.4843 6.83664 15.5005 6.91797 15.5005 7.0001C15.5005 7.08224 15.4843 7.16357 15.4529 7.23944C15.4214 7.31531 15.3753 7.38424 15.3172 7.44229Z"
				fill="#111827"
			/>
		</svg>
	);
}

export default ArrowIcon;
